import React from "react";
import ExternalWebsiteEmbed from "./ExternalWebsiteEmbed";
import "./ExternalWebsite.css";
import { useUser } from "../../../context/UserContext";

function ExternalWebsite() {
  const { user } = useUser();
  // const websiteUrl = "https://www.google.com/search?igu=1";
  const websiteUrl =
    "https://salesplay.marketsandmarkets.com/get_inside_sp/" +
    user?.email +
    "/" +
    user?.company_name_for_growth_iq;
  return (
    <div>
      <ExternalWebsiteEmbed url={websiteUrl} title="External Content" />
    </div>
  );
}

export default ExternalWebsite;
